import React from 'react'
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const BrandItem = ({url,imageObject }) => {
    const image = getImage(imageObject)
    return (
        <div className="w-full aspect-w-1 aspect-h-1">
            <div className="p-4 flex justify-center items-center w-full h-full bg-white rounded">
                { url !== '#' ? <a href={ url } target="_blank" rel="noopener noreferrer"><GatsbyImage image={image} alt='' /></a> :<GatsbyImage image={image} alt='' /> }
            </div>
        </div>
    )
}

export default BrandItem
